import { render, staticRenderFns } from "./VacancyStepStore.vue?vue&type=template&id=fd0e2baa&scoped=true&"
import script from "./VacancyStepStore.vue?vue&type=script&lang=js&"
export * from "./VacancyStepStore.vue?vue&type=script&lang=js&"
import style0 from "./VacancyStepStore.vue?vue&type=style&index=0&id=fd0e2baa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0e2baa",
  null
  
)

/* custom blocks */
import block0 from "./VacancyStepStore.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyStepStore.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
